import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import useGetAuthSessionQuery from '~/features/auth/hooks/useGetAuthSessionQuery'
import { EClientPath } from '~/models/api'
import { store } from '~/store'

const useRedirectListener = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [setUser, user] = store((state) => [state.setUser, state.user])
  const { data: authSession } = useGetAuthSessionQuery()

  useEffect(() => {
    if (user.signInRedirectPath && authSession?.cognitoUid) {
      // if there is a tab open with an active chat conversation, don't redirect if user signs in from another tab
      if (!pathname.includes(EClientPath.chatBase)) {
        navigate(user.signInRedirectPath)
      }

      setUser({ signInRedirectPath: null })
    }
  }, [setUser, navigate, pathname, user, authSession?.cognitoUid])

  // If user is logged in and on login or register page, redirect to overview
  useEffect(() => {
    if (
      authSession?.cognitoUid &&
      [EClientPath.login, EClientPath.register].includes(
        pathname as EClientPath,
      )
    ) {
      navigate(EClientPath.overview)
    }
  }, [authSession?.cognitoUid, navigate, pathname])
}

export default useRedirectListener
